type ToggleButtonProps = {
  onClick: (value: boolean) => void;
  toggled: boolean;
  label?: string;
  className?: string;
  buttonClassName?: string;
  knobClassName?: string;
  labelAfter?: boolean;
  darkMode?: boolean;
};

export const ToggleButton = ({
  onClick,
  toggled,
  label,
  className,
  buttonClassName,
  knobClassName,
  labelAfter,
  darkMode,
}: ToggleButtonProps) => {
  return (
    <label className={`flex items-center gap-2 ${className ?? 'prose-paragraphBase'}`}>
      {!labelAfter && <span className=''>{label}</span>}
      <button
        type='button'
        aria-pressed={toggled}
        className={`w-14 h-8 flex items-center rounded-full cursor-pointer transition-colors duration-300 ${
          toggled ? 'bg-primary-100' : 'bg-gray-20'
        } ${buttonClassName ?? ''}`}
        onClick={() => onClick(!toggled)}
      >
        <div
          className={`relative bg-white border-2 w-8 h-8 rounded-full shadow-md flex items-center justify-center transition-transform duration-500 ${
            toggled ? 'translate-x-6 border-primary-100' : ' border-gray-20'
          } ${knobClassName ?? ''}`}
          style={{
            boxShadow: toggled ? '0 4px 16px 0 rgba(251,191,36,0.25)' : '0 2px 8px 0 rgba(0,0,0,0.08)',
            transition:
              'transform 0.5s cubic-bezier(0.4,0,0.2,1), box-shadow 0.5s cubic-bezier(0.4,0,0.2,1), border-color 0.5s cubic-bezier(0.4,0,0.2,1)',
          }}
        >
          {darkMode && (
            <>
              <span
                className='absolute inset-0 flex items-center justify-center transition-opacity transition-transform duration-500'
                style={{
                  opacity: toggled ? 1 : 0,
                  transform: toggled ? 'scale(1) rotate(0deg)' : 'scale(0.8) rotate(-20deg)',
                  transition: 'opacity 0.5s cubic-bezier(0.4,0,0.2,1), transform 0.5s cubic-bezier(0.4,0,0.2,1)',
                  zIndex: 2,
                }}
              >
                {/* Moon icon */}
                <svg width='20' height='20' viewBox='0 0 20 20' fill='none'>
                  <path
                    d='M14.5 16c-3.59 0-6.5-2.91-6.5-6.5 0-2.13 1.04-4.03 2.77-5.19.32-.21.39-.67.13-.94A.75.75 0 0 0 9.5 3C6.46 4.13 4.25 7.09 4.5 10.5c.29 3.86 3.38 6.96 7.24 7.24 3.41.25 6.37-1.96 7.5-5-.07-.34-.53-.41-.74-.13A6.48 6.48 0 0 1 14.5 16z'
                    fill='#fff'
                  />
                  <circle cx='15.5' cy='7.5' r='1.2' fill='#fff' opacity='0.6' />
                  <circle cx='12.5' cy='10.5' r='0.7' fill='#fff' opacity='0.4' />
                </svg>
              </span>
              <span
                className='absolute inset-0 flex items-center justify-center transition-opacity transition-transform duration-500'
                style={{
                  opacity: toggled ? 0 : 1,
                  transform: toggled ? 'scale(0.8) rotate(20deg)' : 'scale(1) rotate(0deg)',
                  transition: 'opacity 0.5s cubic-bezier(0.4,0,0.2,1), transform 0.5s cubic-bezier(0.4,0,0.2,1)',
                  zIndex: 1,
                }}
              >
                {/* Sun icon */}
                <svg width='20' height='20' viewBox='0 0 20 20' fill='none'>
                  <circle cx='10' cy='10' r='5' fill='#000' />
                  <g stroke='#000' strokeWidth='2'>
                    <line x1='10' y1='1' x2='10' y2='3' />
                    <line x1='10' y1='17' x2='10' y2='19' />
                    <line x1='1' y1='10' x2='3' y2='10' />
                    <line x1='17' y1='10' x2='19' y2='10' />
                    <line x1='4.22' y1='4.22' x2='5.64' y2='5.64' />
                    <line x1='14.36' y1='14.36' x2='15.78' y2='15.78' />
                    <line x1='4.22' y1='15.78' x2='5.64' y2='14.36' />
                    <line x1='14.36' y1='5.64' x2='15.78' y2='4.22' />
                  </g>
                </svg>
              </span>
            </>
          )}
        </div>
      </button>
      {labelAfter && <span className=''>{label}</span>}
    </label>
  );
};
